var $ = require('jquery');

$(function () {
    $('.link--menu').on('click', function (e) {
        e.preventDefault(); 
        $('body').toggleClass('show-header-menu').removeClass('show-location-menu');
        $('.header__main-menu__links').slideToggle();
        $('.locations').slideUp();

        // if class open is added change overflow-y; this is a mobile menu
        if ($('body').hasClass('show-header-menu')) {
            $('html').css('overflow-y', 'hidden');
            $('.content-access__overlay').addClass('open'); 
            setTimeout(function () { setScrollableNav('.header__main-menu__links', 'header__main-menu__links', 'scrollable_nav'); }, 500);
        }
        else {
            $('.content-access__overlay').removeClass('open');
            $('.header__main-menu').removeClass('scroll-hidden');
            $('.header__utility-menu').removeClass('scroll-hidden');
            subNavClosed();
        }

        $('.content-access__overlay').removeClass('open');
        $('.locations').removeClass('scrollable_locations');
        $('.locations_global-directory--overlay').removeClass('overlay-active');
        $('.header__main-menu').removeClass('scroll-hidden');
        $('.header__utility-menu').removeClass('scroll-hidden');
    });
    $('.header__main-menu__group').on('click', function (e) {
        if (!$(this).hasClass("header__main-menu__group__no-submenu-link")) {
            e.preventDefault();
            $(this).siblings('.header__main-menu__group')
                .children('.header__main-menu__primary-link').removeClass('open')
                .next('.header__sub-menu').slideUp();
            $(this).children('.header__main-menu__primary-link').toggleClass('open')
                .next('.header__sub-menu').slideToggle();

            if ($(this).children('.header__main-menu__primary-link.header__main-menu__submenu-link.open').length > 0) {
                $('.content-access__overlay').addClass('open');
            }
            else {
                $('.content-access__overlay').removeClass('open');
                $('.header__main-menu').removeClass('scroll-hidden');
                $('.header__utility-menu').removeClass('scroll-hidden');
                subNavClosed();
            }

            if (window.innerWidth > 991) {
                $.each($('.header__sub-menu'), function (key, value) {

                    if ($(value).is(':visible')) {
                        setTimeout(function () { setScrollableNav($(value), 'header__sub-menu', 'scrollable_nav'); }, 500);

                        //return false;
                    }
                });
            } else {
                $('html').css('overflow-y', 'hidden');
                setTimeout(function () {
                    setScrollableNav('.header__main-menu__links', 'header__main-menu__links', 'scrollable_nav');
                },
                    500);
            }
        }
    });

    $('.header__sub-menu__see-all-wrapper--desktop__close').on('click', function (e) {
        $(this).removeClass('show-header-menu');
        $('.header__sub-menu').slideUp();
        $('.header__main-menu__primary-link').removeClass('open');

        $('.content-access__overlay').removeClass('open');
        $('.header__main-menu').removeClass('scroll-hidden');
        $('.header__utility-menu').removeClass('scroll-hidden');
        subNavClosed();
    });
     
    $('.header__main-menu__links .dropdown-filter').on('click', function () {
        $(this).children('.dropdown-filter__dropdown').slideToggle();
    });

    $('body').on('click', function () {
        if (window.innerWidth <= 991) {
            $('.header__main-menu__links').slideUp();
        }

        $(this).removeClass('show-header-menu');
        $('.locations').slideUp();
        $('.header__sub-menu').slideUp();
        $('.header__main-menu__primary-link').removeClass('open');

        $('.content-access__overlay').removeClass('open');
        $('.header__main-menu').removeClass('scroll-hidden');
        $('.header__utility-menu').removeClass('scroll-hidden');
        subNavClosed();
    });

    $('.link--menu, .header__main-menu__group, .header__sub-menu, .header__main-menu__links').on('click', function (e) {
        e.stopPropagation();
    });

    $(window).resize(function () {
        $("body").trigger("click");

        $(this).removeClass('show-header-menu');
        //$('.header__main-menu__links').slideToggle(); 
        $('.locations').slideUp();
        $('.header__sub-menu').slideUp();
        $('.header__main-menu__links').slideUp();
        $('.header__main-menu__primary-link').removeClass('open');

        $('.content-access__overlay').removeClass('open');
        $('.header__main-menu').removeClass('scroll-hidden');
        $('.header__utility-menu').removeClass('scroll-hidden');
        subNavClosed();
    });

    // close menu navigation elements if not a click on a sub group
    function subNavClosed() {
        if ($('body').hasClass('show-header-menu')) {
            // do nothing
        }
        else {
            $('html').removeAttr('style');
            // clear desktop scrollable_nav class
            $('.header__sub-menu').removeClass('scrollable_nav');
            // clear mobile scrollable_nav class
            $('.header__main-menu__links').removeClass('scrollable_nav');
        }
    }
});
